import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

const GetServiceLayerIdsFragment = graphql(/* GraphQL */ `
  fragment GetServiceLayerIdsFragment on Product {
    productHints {
      serviceLayerId
    }
    ecoLabels {
      serviceLayerId
    }
    legalHints {
      serviceLayerId
    }
  }
`);

export type GetServiceLayerIdsProps = FragmentType<typeof GetServiceLayerIdsFragment>;

export const getServiceLayerIds = (data: GetServiceLayerIdsProps) => {
  const { ecoLabels, legalHints, productHints } = getFragmentData(GetServiceLayerIdsFragment, data);

  const serviceLayerIds: string[] = [];

  [productHints, ecoLabels, legalHints].forEach((serviceLayerContainer) => {
    serviceLayerContainer.forEach((item) => {
      if (item.serviceLayerId) {
        serviceLayerIds.push(item.serviceLayerId);
      }
    });
  });

  return serviceLayerIds;
};
